// src/components/Hero.js
import heroImage from '../assets/hero-image-1.png';
import './Hero.css';

const Hero = () => {
  return (
    <div className="hero-section">
      <div id="hero" className="hero-container">
        <div className="hero-text-col">
          <h1>Take Control of Your Freight -<br/>Without the Overhead</h1>

          <p>
            Simplify logistics, optimize workflows, and reduce operational costs.
          </p>

          <a 
            href="/tms/login"
            target="_blank"
            rel="noopener noreferrer"
            className="hero-tms-app-link"
          >
            Let's Get Started
          </a>
        </div>

        <div className="hero-image-col">
          <img src={heroImage} alt="trucks, trains, boats, shipping containers" className="hero-img" />
        </div>
      </div>
    </div>
  );
};

export default Hero;
